import { TagManager } from '@navent-jobs/config'

export const DataLayers = {
  onload: (filtersApplied, ubicacion, isLogged) => {
    /**
     * Debe dispararse cuando realiza el onload de la página de Listado
     *
     * El objetivo es guardar ciertos datos de navegación, los cuales luego
     * alimentarán tanto a agrupación de contenido como Dimensiones Personalizadas.
     */

    const getFilterName = key => {
      if (filtersApplied) {
        const result = filtersApplied.find(filter => filter.type === key)
        return result && result.name
      }
    }

    return TagManager.Push({
      event: 'track_content_group',
      area: getFilterName('area') || 'N/A',
      subarea: getFilterName('subarea') || 'N/A',
      provincia: getFilterName('provincia') || 'N/A',
      ciudad: getFilterName('localidad') || 'N/A',
      ubicacion,
      tipoPuesto: getFilterName('tipo_trabajo') || 'N/A',
      modalidad: getFilterName('modalidad_trabajo') || 'N/A',
      experiencia: getFilterName('nivel_laboral') || 'N/A',
      aptoDiscapacitado: getFilterName('apto_discapacitado') ? 'Si' : 'No',
      isLogged: isLogged ? 'Si' : 'No',
    })
  },
  ordenamiento: orden => {
    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Listado',
      eventAction: 'Ordenamiento',
      eventLabel: orden,
    })
  },
}
